import React, { Suspense, useEffect } from "react";
import {
    BrowserRouter as Router,
    Route,
    Routes,
    useNavigate
} from "react-router-dom";

import { AuthProvider } from "@/services/authContext";
import ProtectedRoute from "@/services/ProtectedRoute";
import { ErrorBoundary } from "react-error-boundary";

import DashBoard from "@/components/layout/DashBoard";
import { allRoutes } from "@/routes";
import EventPage from "@/pages/event/EventPage";

const ErrorPage = React.lazy(() => import("@/pages/error/ErrorPage"));

const GoToHome = () => {
    const navigate = useNavigate();
    useEffect(() => {
        navigate("/");
    }, [navigate]);
    return null;
};

const AppRoutes = () => {
    return (
        <Suspense
            fallback={
                <div className="text-2xl text-black-600 text-center p-4 bg-gray-100 rounded-lg shadow-lg animate-pulse">
                    로딩중.......
                </div>
            }
        >
            <Routes>
                {/* ✅ /event 는 완전 독립, DashBoard 밖 */}
                <Route path="/event" element={<EventPage />} />

                {/* ✅ 나머지 경로는 전부 DashBoard 안에서 렌더 */}
                <Route element={<DashBoard />}>
                    {allRoutes &&
                        allRoutes.map((route, index) => (
                            <Route
                                key={index}
                                path={route.path}
                                element={
                                    route.requiredRoles === null ? (
                                        route.element
                                    ) : (
                                        <ProtectedRoute
                                            element={route.element}
                                            requiredRoles={route.requiredRoles}
                                        />
                                    )
                                }
                            />
                        ))}

                    {/* 알 수 없는 경로 → 홈으로 */}
                    <Route path="*" element={<GoToHome />} />
                </Route>
            </Routes>
        </Suspense>
    );
};

const App = () => {
    return (
        <Router>
            <AuthProvider>
                <ErrorBoundary
                    fallback={
                        <ErrorPage errorMessage={"처리중 오류가 발생하였습니다."} />
                    }
                >
                    <AppRoutes />
                </ErrorBoundary>
            </AuthProvider>
        </Router>
    );
};

export default App;
